import styled from 'styled-components';
import { bordaArredondar, espacamento } from '../../styles/constants/sizes';

export const Orientacoes = styled.div`
  background-color: #fff8d7;
  border-radius: ${bordaArredondar}px;
  border: 1px solid #b38f00;
  padding: ${espacamento.extraPequeno}px;
  color: #997a00;
`;

export const OrientacoesLocalizacao = styled.div`
  background-color: #ed878c;
  border-radius: ${bordaArredondar}px;
  border: 1px solid #ef676e;
  padding: ${espacamento.extraPequeno}px;
  color: #fff;
`;
